import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tabs, Spin } from 'antd'
import NumberFormat from 'react-number-format'

const TabPane = Tabs.TabPane

class JobAiaHistoryRevision extends Component {
  static propTypes = {
    revisionsHistory: PropTypes.array,
    loadingHistoryRevisions: PropTypes.bool
  }

  render() {
    const { revisionsHistory, loadingHistoryRevisions } = this.props
    return (
      <Spin spinning={loadingHistoryRevisions}>
        <Tabs tabPosition="left">
          {revisionsHistory &&
            revisionsHistory.length > 0 &&
            revisionsHistory.map((revision, index) => {
              return (
                <TabPane tab={revision.currentRevisionNumber} key={index}>
                  <div className="row">
                    <div className="col-6">
                      <div className="row">
                        <div className="col-6">
                          <div className="row">
                            <div className="col-12">
                              <strong>AIA Number</strong>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">{revision.number}</div>
                          </div>
                          <div className="row">
                            <div className="col-12 ">
                              <strong>AIA Date</strong>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">{revision.aia_date}</div>
                          </div>
                          <div className="row">
                            <div className="col-12 ">
                              <strong>Descritpion</strong>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">{revision.description}</div>
                          </div>
                          <div className="row">
                            <div className="col-12 ">
                              <strong>Internal Amount</strong>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              <NumberFormat
                                value={revision.internal_amount}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                                renderText={value => <div>{value}</div>}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="row">
                            <div className="col-12 ">
                              <strong>Vendor Amount</strong>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              <NumberFormat
                                value={revision.vendor_amount}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                                renderText={value => <div>{value}</div>}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 ">
                              <strong>Total Amount</strong>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              <NumberFormat
                                value={
                                  parseInt(revision.internal_amount, 10) +
                                  parseInt(revision.vendor_amount, 10)
                                }
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                                renderText={value => <div>{value}</div>}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 ">
                              <strong>Assigned To</strong>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              {revision.assigned_to ? revision.assigned_to : '--'}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 ">
                              <strong>Status</strong>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">{revision.status}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="row">
                        <div className="col-6">
                          <div className="row">
                            <div className="col-12">
                              <strong>Created Date</strong>
                            </div>
                            <div className="col-12">{revision.created_date}</div>
                            <div className="col-12">
                              <strong>Created By</strong>
                            </div>
                            <div className="col-12">{`${revision.created_by_first_name} ${
                              revision.created_by_last_name
                            }`}</div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="row">
                            <div className="col-12">
                              <strong>Updated Date</strong>
                            </div>
                            <div className="col-12">{revision.updated_date}</div>
                            <div className="col-12">
                              <strong>Updated By</strong>
                            </div>
                            <div className="col-12">{`${revision.updated_by_first_name} ${
                              revision.updated_by_last_name
                            }`}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
              )
            })}
        </Tabs>
      </Spin>
    )
  }
}

export default JobAiaHistoryRevision



// WEBPACK FOOTER //
// ./src/components/jobs/aia/JobAiaHistoryRevision.js